export default __webpack_public_path__ + "assets/images/Landing_page_img1.74b59956.svg";